

























import {defineComponent, onMounted, PropType} from '@vue/composition-api'
import {useActions, useGetters} from 'vuex-composition-helpers'

import service from '@/apps/FavoriteAppsWidget/services'

import LoaderComponent from '@/shared/components/Loader.vue'
import AppListComponent from './AppList.vue'
import AppListEditModeComponent from './AppListEditMode.vue'

export default defineComponent({
    name: 'FavoriteAppsComponent',
    components: {
        LoaderComponent,
        AppListComponent,
        AppListEditModeComponent
    },
    props: {
        configRaw: {
            type: Object as PropType<any>,
            required: true
        }
    },
    setup(props) {
        const {setConfig, setError, setLoading, setFavoriteApps, setApps} = useActions([
            'setConfig',
            'setError',
            'setLoading',
            'setFavoriteApps',
            'setApps'
        ])
        const {getConfig, getLoading} = useGetters(['getConfig', 'getLoading'])
        setConfig(props.configRaw)

        const loadMockApps = (loadAll: boolean) => {
            // @ts-ignore
            const allApps = require('./../statics/AllApps.json')
            setApps(loadAll ? allApps : [])
            setFavoriteApps(allApps.slice(0,4))
            setLoading(false)
        }
        
        const handleError = (error: Error) => {
            console.error(error)
            setError(getErrorText())
        }
        
        const loadAppsData = async (loadAll: boolean) => {
            if (process.env.NODE_ENV === "development") {
                loadMockApps(loadAll)
            } else {
                setLoading(true)
                try {
                    if (loadAll) {
                        const [favorites, all] = await Promise.all([
                            service.userPreferences.getFavoriteApps(getConfig.value.language),
                            service.userPreferences.getAllApps(getConfig.value.language)
                        ])
                        setFavoriteApps(favorites.data)
                        setApps(all.data)
                    } else {
                        const favorites = await service.userPreferences.getFavoriteApps(getConfig.value.language)
                        setFavoriteApps(favorites.data)
                    }
                } catch (error) {
                    handleError(error as Error)
                } finally {
                    setLoading(false)
                }
            }
        }
    
        const loadData = async (): Promise<void> => {
            await loadAppsData(getConfig.value.editMode)
        }

        const getErrorText = (): string => {
            return getConfig.value.language.toLowerCase() === "nl"
                ? "Er gaat iets fout, probeer het later nog een keer"
                : "Something went wrong, please try again later"
        }

        onMounted(async() => {
            await loadData()
        })

        return {
            getLoading,
            getConfig
        }
    }

})
